export default class Contacts {
    static initial() {
        mapboxgl.accessToken = "pk.eyJ1IjoibWF4aW0iLCJhIjoiSzRjQzNUdyJ9.iO0DsYaWkJWqusRwnmi2HA";
        this.map();
        this.lat = parseFloat(lat);
        this.lng = parseFloat(lng);
        this.LANGUAGE = document.documentElement.lang;
    }


    /**
     * Initial map
     */
    static map() {
        let self = this,
            map = null;

        //Initial map after open popup
        $('.fade-popup').bind('fade.refresh.trigger', function () {
            initialMap();
            $('.fade-popup').unbind('fade.refresh.trigger');
        });

        function initialMap() {
            let geojson = {
                'type': 'FeatureCollection',
                'features': [
                    {
                        'type': 'Feature',
                        'properties': {
                            'iconSize': [40, 40]
                        },
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [self.lat, self.lng]
                        }
                    }
                ]
            };

           map = new mapboxgl.Map({
                container: 'mapBox',
                style: 'mapbox://styles/mapbox/streets-v11',
                center: [self.lat, self.lng],
                zoom: 12
            });

            map.on('style.load', function () {
                map.setLayoutProperty('country-label', 'text-field', ['get', 'name_' + self.LANGUAGE]);
                map.setLayoutProperty('road-label', 'text-field', ['get', 'name_' + self.LANGUAGE]);
                //map.setLayoutProperty('place-label', 'text-field', ['get', 'name_' + self.LANGUAGE]);
            });

            //Add points on map
            geojson.features.forEach(function(marker) {
                let el = document.createElement('div');
                el.className = 'marker';
                el.style.backgroundImage = "url(/assets/images/place.png)";
                el.style.width = marker.properties.iconSize[0] + 'px';
                el.style.height = marker.properties.iconSize[1] + 'px';

                new mapboxgl.Marker(el)
                    .setLngLat(marker.geometry.coordinates)
                    .addTo(map);
            });
        }
    }
}
